import styled from 'styled-components';

export const ModalOverlay = styled.div<{ $visible?: boolean }>`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    display: ${({ $visible = true }) => ($visible ? 'flex' : 'none')};
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
`;

export const ModalPanel = styled.div<{ $width?: string }>`
    background: #fff;
    border-radius: 8px;
    padding: 24px;
    width: 90%;
    max-width: ${({ $width = '500px' }) => $width};
    max-height: 85vh;
    overflow-y: auto;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
`;

export const ModalTitle = styled.h2`
    font-size: 18px;
    font-weight: 600;
    color: #111;
    margin: 0;
    letter-spacing: -0.01em;
`;

export const ModalSubtitle = styled.p`
    font-size: 13px;
    color: #999;
    margin: 4px 0 0;
`;

export const ModalCloseButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 4px;
    border: none;
    background: transparent;
    color: #999;
    cursor: pointer;
    flex-shrink: 0;

    &:hover {
        background: #f0f0f0;
        color: #555;
    }
`;

export const ModalBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    font-size: 14px;
    color: #555;
`;

export const ModalActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
`;

export const ModalButton = styled.button<{ $variant?: 'primary' | 'secondary' | 'danger' }>`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 14px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    border: ${({ $variant = 'secondary' }) =>
        $variant === 'secondary' ? '1px solid #e0e0e0' : 'none'};
    background: ${({ $variant = 'secondary' }) => {
        switch ($variant) {
            case 'primary': return '#111';
            case 'danger': return '#b91c1c';
            default: return '#fff';
        }
    }};
    color: ${({ $variant = 'secondary' }) => {
        switch ($variant) {
            case 'primary':
            case 'danger':
                return '#fff';
            default:
                return '#333';
        }
    }};

    &:hover:not(:disabled) {
        opacity: 0.85;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const ModalInput = styled.input`
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    font-size: 13px;
    font-family: inherit;
    color: #333;
    background: #fff;

    &:focus {
        outline: none;
        border-color: #ccc;
    }
`;

export const ModalTextarea = styled.textarea`
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    font-size: 13px;
    font-family: inherit;
    color: #333;
    background: #fff;
    resize: vertical;
    min-height: 80px;

    &:focus {
        outline: none;
        border-color: #ccc;
    }
`;

export const ModalLabel = styled.label`
    font-size: 13px;
    font-weight: 500;
    color: #333;
`;

export const ModalStatusMessage = styled.div<{ $tone?: 'success' | 'error' | 'info' }>`
    padding: 10px 12px;
    border-radius: 6px;
    font-size: 13px;
    background: ${({ $tone = 'info' }) => {
        switch ($tone) {
            case 'success': return '#dcfce7';
            case 'error': return '#fee2e2';
            default: return '#f0f0f0';
        }
    }};
    color: ${({ $tone = 'info' }) => {
        switch ($tone) {
            case 'success': return '#166534';
            case 'error': return '#b91c1c';
            default: return '#555';
        }
    }};
`;
